module.exports = __webpack_public_path__ + "img/chat_pl.0a1a0592.svg";